<template lang="html">
    <div>
        <h4 class="mb-1">Calendar Filters</h4>

        <checkbox @input="filtersChanged" v-model="getCurrentAccountType.isToHideCalendarEventCanceled">
            Hide canceled events
        </checkbox>

        <checkbox @input="filtersChanged" v-model="getCurrentAccountType.isToHideCalendarEventEmpty">
            Hide events with no bookings
        </checkbox>

        <checkbox @input="filtersChanged" v-model="getCurrentAccountType.showHidenProductsOnCalendar">
            Show Plan Products
        </checkbox>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import { eventHub } from '@/main'

    export default {
        computed: {
            ...mapGetters([
                'getCurrentAccountType',
            ])
        },
        methods: {
            ...mapActions([
                'updateSupplierSettings'
            ]),
            filtersChanged() {
                this.updateSupplierSettings(this.getCurrentAccountType).then(() => {
                    this.$emit('change');
                });
            },
        }
    }
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// calendarFilters.vue?66337c57